import type { GetterTree } from "vuex";
import type { ScenarioState, Scenario, RootState } from "@/types";

export const getters: GetterTree<ScenarioState, RootState> = {
  getScenarios(state): Scenario[] {
    return state.scenarios.data;
  },
  getScenariosLoading(state): boolean {
    return state.scenarios.loading;
  },
  getScenariosError(state): string | null {
    return state.scenarios.error;
  },
  getScenario(state): Scenario {
    return state.scenario.data;
  },
  getScenarioLoading(state): boolean {
    return state.scenario.loading;
  },
  getScenarioError(state): string | null {
    return state.scenario.error;
  },
  getScenariosListById(state): Scenario[] {
    return state.scenariosByIDList.data;
  },
  getScenariosListByIdLoading(state): boolean {
    return state.scenariosByIDList.loading;
  },
  getScenariosListByIdError(state): string | null {
    return state.scenariosByIDList.error;
  },
};
